.addWrapper {
  display: flex;
  align-items: center;
  flex: 1;
}

.rule {
  background-color: var(--gray-light);
  display: flex;
  flex: 1;
  margin-left: 0.5rem;
  height: 1px;
}

.fieldWrapper {
  display: flex;
  flex: 1;
}

.errorWrapper {
  display: flex;
  flex-direction: column;
}

.error {
  color: var(--danger);
  padding-bottom: 0.5rem;
}
